import MultiSelect from './multi-select';
import ZmInput from '../input';
import ZmButton from '../button';
import ZmCheckbox from '../checkbox';
import ZmScrollbar from '../scrollbar';
import ZmCheckboxList from '../checkbox-list';
import ZmTag from '../tag';
import ZmTree from '../tree';

MultiSelect.install = function(Vue) {
  Vue.component(MultiSelect.name, MultiSelect);
  Vue.component(ZmInput.name, ZmInput);
  Vue.component(ZmButton.name, ZmButton);
  Vue.component(ZmCheckbox.name, ZmCheckbox);
  Vue.component(ZmScrollbar.name, ZmScrollbar);
  Vue.component(ZmTag.name, ZmTag);
  Vue.component(ZmTree.name, ZmTree);
  Vue.component(ZmCheckboxList.name, ZmCheckboxList);
};

export default MultiSelect;
